import part1 from './en-part1.js'
import part2 from './en-part2.js'
import part3 from './en-part3.js'
import supplementEn from './faqSupplementEn.js'
import purchaseGuideEn from './faqPurchaseGuideEn.js'
import { processGeoFaq } from './faqCta.js'

function mergeFaqSupplements(key) {
  return [...(supplementEn[key] || []), ...(purchaseGuideEn[key] || [])]
}

export function mergeGeoContent(baseMessages) {
  const geo = { ...part1, ...part2, ...part3 }
  Object.keys(geo).forEach((key) => {
    const merged = { ...(baseMessages[key] || {}), ...geo[key] }
    if (merged.geoFaq) {
      merged.geoFaq = processGeoFaq(merged.geoFaq, key, 'EN', mergeFaqSupplements(key))
    }
    baseMessages[key] = merged
  })
  return baseMessages
}
